// Platform detection based on Ionic Framework
// See https://github.com/ionic-team/ionic-framework/blob/main/core/src/utils/platform.ts

export class Platforms {

    detectPlatforms(win) {
        return (Object.keys(this.PLATFORMS_MAP)).filter((p) => {
            return this.PLATFORMS_MAP[p](win);
        });
    }

    isMobileWeb(win) { return this.isMobile(win) && !this.isHybrid(win); }

    isIpad(win) {
        // iOS 12 and below
        if (this.testUserAgent(win, /iPad/i)) {
            return true;
        }

        // iOS 13+
        if (this.testUserAgent(win, /Macintosh/i) && this.isMobile(win)) {
            return true;
        }

        return false;
    }

    isIphone(win) { return this.testUserAgent(win, /iPhone/i); }

    isIOS(win) { return this.testUserAgent(win, /iPhone|iPod/i) || this.isIpad(win); }

    isAndroid(win) { return this.testUserAgent(win, /android|sink/i); }

    isWindowsOS(win) { return this.testUserAgent(win, /windows/i); }

    isAndroidTablet(win) { 
        return this.isAndroid(win) && !this.testUserAgent(win, /mobile/i);
    }

    isPhablet(win) {
        const width = win.innerWidth;
        const height = win.innerHeight;
        const smallest = Math.min(width, height);
        const largest = Math.max(width, height);

        return smallest > 390 && smallest < 520 && largest > 620 && largest < 800;
    };

    isTablet(win) {
        const width = win.innerWidth;
        const height = win.innerHeight;
        const smallest = Math.min(width, height);
        const largest = Math.max(width, height);

        return this.isIpad(win) || this.isAndroidTablet(win) || (smallest > 460 && smallest < 820 && largest > 780 && largest < 1400);
    };

    isMobile(win) { return this.matchMedia(win, '(any-pointer:coarse)') && !this.isWindowsOS(win); }

    isDesktop(win) { return !this.isMobile(win); }

    isHybrid(win) { return this.isCordova(win) || this.isCapacitorNative(win); }

    isCordova(win) { return !!(win['cordova'] || win['phonegap'] || win['PhoneGap']); }

    isCapacitorNative(win) {
    const capacitor = win['Capacitor'];
    return !!(capacitor && capacitor.isNative);
    };

    isElectron(win) { return this.testUserAgent(win, /electron/i); }

    isPWA(win) {
        return !!(win.matchMedia && win.matchMedia('(display-mode: standalone)').matches || win.navigator.standalone);
    }

    testUserAgent(win, expr) { return  expr.test(win.navigator.userAgent); }

    matchMedia(win, query) { return win.matchMedia && win.matchMedia(query).matches; }

    constructor() {
        this.PLATFORMS_MAP = {
            ipad: this.isIpad.bind(this),
            iphone: this.isIphone.bind(this),
            ios: this.isIOS.bind(this),
            android: this.isAndroid.bind(this),
            phablet: this.isPhablet.bind(this),
            tablet: this.isTablet.bind(this),
            cordova: this.isCordova.bind(this),
            capacitor: this.isCapacitorNative.bind(this),
            electron: this.isElectron.bind(this),
            pwa: this.isPWA.bind(this),
            mobile: this.isMobile.bind(this),
            mobileweb: this.isMobileWeb.bind(this),
            desktop: this.isDesktop.bind(this),
            hybrid: this.isHybrid.bind(this),
        };
    }
}